import { removeListeners } from './removeListeners.js';

import {
	GoogleAuthProvider,
	getAuth,
	signInWithPopup,
	sendSignInLinkToEmail,
	isSignInWithEmailLink,
	signInWithEmailLink
} from 'firebase/auth';

export const logout = async () => {
	// const homeNavElem = document.getElementById('home-navlink');
	// homeNavElem && homeNavElem.click();

	removeListeners();

	const auth = getAuth();

	await auth.signOut();
};

export const login = async () => {
	try {
		const provider = new GoogleAuthProvider();
		const auth = getAuth();

		await signInWithPopup(auth, provider);
	} catch (err) {
		console.error(err);
	}
};

export const toggleShow = (elemId) => {
	const elem = document.getElementById(elemId);

	elem && elem.classList.toggle('h-0');

	elem && elem.classList.toggle('h-80');
};

export const signInWithEmail = async (loginResponse, userEmail) => {
	const url = window.location.origin + window.location.pathname;
	loginResponse = await emailLogin(url, userEmail);

	if (loginResponse === 'email sent') {
		const checkElem = document.getElementById('Check-Email');
		checkElem && checkElem.classList.remove('hidden');

		setTimeout(() => {
			toggleShow('Email-SignIn');

			checkElem && checkElem.classList.add('hidden');
		}, 5000);
	} else {
		const emailLoginElem = document.getElementById('Email-Login-Error');
		emailLoginElem && emailLoginElem.classList.remove('hidden');
	}
};

export const emailLogin = async (url, email) => {
	const actionCodeSettings = {
		url,
		handleCodeInApp: true
	};

	const auth = getAuth();

	try {
		await sendSignInLinkToEmail(auth, email, actionCodeSettings);

		window.localStorage.setItem('emailForSignIn', email);

		return 'email sent';
	} catch (err) {
		const errorCode = err.code;
		const errorMessage = err.message;
		console.error('errorCode:', errorCode);
		console.error('errorMessage:', errorMessage);
		return errorMessage;
	}
};

export const checkEmailLogin = async () => {
	const auth = getAuth();
	if (isSignInWithEmailLink(auth, window.location.href)) {
		console.log('href is link from email signin');

		let email = window.localStorage.getItem('emailForSignIn');

		if (!email) {
			email = window.prompt('Please provide your email for confirmation');
		}
		try {
			await signInWithEmailLink(auth, email || '');
			window.localStorage.removeItem('emailForSignIn');

			const homeNavElem = document.getElementById('home-navlink');
			homeNavElem && homeNavElem.click();
		} catch (err) {
			console.error(err);

			const homeNavElem = document.getElementById('home-navlink');
			homeNavElem && homeNavElem.click();
		}
	} else {
		console.log('no email signin link detected');
	}
};
